import { apiSlice } from "@/redux/apiSlice";
import {
  BankPaymentInitiateRequest,
  BankPaymentInitiateResponse,
  BankPaymentCallbackResponse,
  AlfalahCallbackResponse,
} from "@/types/bank-payment";

export const bankPaymentApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      initiateBankPayment: builder.mutation<
        BankPaymentInitiateResponse,
        BankPaymentInitiateRequest
      >({
        query: ({ authorization, ...payload }) => ({
          url: "/payments/execute",
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: authorization,
          },
          body: payload,
        }),
        invalidatesTags: ["BankPayment"],
      }),
      getBankPaymentCallback: builder.mutation<
        BankPaymentCallbackResponse,
        { token: string }
      >({
        query: ({ token }) => ({
          url: `/bank/callback`,
          method: "POST",
          body: { token },
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["BankPayment"],
      }),
      processAlfalahCallback: builder.mutation<
        AlfalahCallbackResponse,
        { order_id: string }
      >({
        query: (body) => ({
          url: "/alfalah/callback",
          method: "POST",
          body,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["BankPayment"],
      }),
    };
  },
});

export const {
  useInitiateBankPaymentMutation,
  useGetBankPaymentCallbackMutation,
  useProcessAlfalahCallbackMutation,
} = bankPaymentApi;
